<template>
  <fragment>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4 mt-3 bg-white">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">User Evaluation</h1>
        <div class="btn-toolbar mb-2 mb-md-0">
        </div>
      </div>

      <div class="bg-light p-2">
        <div class="row align-items-center justify-content-between">
          <div class="col-12 col-md-4 col-xl-6 mb-3">
            <!-- <a
              class="btn btn-sm btn-green"
              title="Add New Record"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              @click="add()"
            >
              <i class="fa-fw fa fa-plus-square"></i> Add New Record
            </a> -->
          </div>
          <div class="col-12 col-sm-auto mb-3 ms-auto">
            <nav class="d-inline-flex align-items-center">
              <b-pagination
                v-model="page"
                :total-rows="countDataList"
                :per-page="pageSize"
                prev-text="Prev"
                next-text="Next"
                @change="handlePageChange"
                size="sm"
              ></b-pagination>
            </nav>
          </div>
        </div>

        <div class="mb-3">
          <div class="table-responsive">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Title</th>
                  <th scope="col">Datetime</th>
                  <th scope="col">Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-if="dataList.length == 0" colspan="12" align="center">There is no data for this page</td>
                </tr>
                <tr v-for="(req, idx) in dataList" :key="req.id">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ req.title }}</td>
                  <td>{{ req.datetime || '-' }}</td>
                  <td>{{ req.type || '-' }}</td>
                  <td>{{ req.site_status.status_name }}</td>
                  <td>
                    <a
                      class="btn btn-sm btn-outline-secondary"
                      @click="edit(req.id)"
                      title="Edit"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      role="button"
                    >
                      <i class="fa-fw fa fa-edit"></i>
                    </a>
                    <a
                      class="btn btn-sm btn-outline-secondary ms-2"
                      @click="edit(req.UserCode)"
                      title="Delete"
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      role="button"
                    >
                      <i class="fa-fw fa fa-trash"></i>
                    </a>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title fs-6" id="exampleModalLabel">
              <i class="fa-fw fa fa-pencil"></i>
              {{formTitle}} User Evaluation
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-4">
            <div class="form-floating mb-2">
              <input
                type="text"
                v-model="form.examination_name"
                class="form-control form-control-sm bg-light"
                placeholder
                autocomplete="off"
              >
              <label>
                <i class="fa fa-server"></i> Name *
              </label>
            </div>
            <div class="form-floating mb-2">
              <input
                type="text"
                v-model="form.unit"
                class="form-control form-control-sm bg-light"
                placeholder
                autocomplete="off"
              >
              <label>
                <i class="fa fa-server"></i> Unit
              </label>
            </div>
            <div class="form-floating mb-2">
              <input
                type="text"
                v-model="form.reverence_value"
                class="form-control form-control-sm bg-light"
                placeholder
                autocomplete="off"
              >
              <label>
                <i class="fa fa-server"></i> Value
              </label>
            </div>
            <div class="form-floating">
              <select
                v-model="form.statusId"
                class="form-select form-select-sm bg-light"
                autocomplete="off"
              >
                <option value disabled hidden>--- Select ---</option>
                <option value="7">Published</option>
                <option value="8">Draft</option>
              </select>
              <label>
                <i class="fa-fw fa fa-sort"></i> Status *
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="onSubmit()" class="btn btn-sm btn-green">
              <i class="fa-fw fa fa-save"></i> Submit
            </button>
            <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">
              <i class="fa-fw fa fa-times"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
		}
	},
	created() {
		if (!this.token) {
		  this.$router.push("/login");
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation'
		})
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `user_evaluation`,
					params: {
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order,
					},
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
